const GET_SKILL_RESOURCES = `query GetSkillResources($skillId: ID!, $studentId: ID!, $limit: Int, $filter: SkillResourcesFilter) {
    skillResources(skillId: $skillId, studentId: $studentId, limit: $limit, filter: $filter) {
      resources {
        label
        resourceUniqueId
        resourceType
        tags
        storyIds
      }
    }
  }`;

export default GET_SKILL_RESOURCES;